/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedFocusDayPagedData } from '../../models/planned-focus-day-paged-data';

export interface GetStudentPlannedFocusDays$Params {
  profileId: string;
  FocusDayId?: string;
  PendingOnly?: boolean;
  ConfirmedOnly?: boolean;
  PageNumber?: number;
  PageSize?: number;
}

export function getStudentPlannedFocusDays(http: HttpClient, rootUrl: string, params: GetStudentPlannedFocusDays$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedFocusDayPagedData>> {
  const rb = new RequestBuilder(rootUrl, getStudentPlannedFocusDays.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.query('FocusDayId', params.FocusDayId, {});
    rb.query('PendingOnly', params.PendingOnly, {});
    rb.query('ConfirmedOnly', params.ConfirmedOnly, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedFocusDayPagedData>;
    })
  );
}

getStudentPlannedFocusDays.PATH = '/studentprofile/{profileId}/plannedfocusday';
